export default __webpack_public_path__ + "static/media/blog-32-image-2.8d06daec.jpg";